import React, { useState } from 'react';

import PropTypes from 'prop-types';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';
import AddAssigneModal from '../addAssigneModal';

const AssignTo = ({ orderData, fetchOrders }) => {
  const { id, isQuoteReference, assignedToSRT } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { assignTo }
  } = localizedStrings;

  const [isAssigneeModalOpen, setIsAssigneeModalOpen] = useState(false);

  const handlesetAssignee = assignee => {
    const { id: assigneeId, name, email } = assignee;
    const body = {
      assignedToSRT: +assigneeId,
      assignedSRTAgentName: name,
      assignedSRTAgentEmail: email
    };
    request.put(`/orders/${id}`, body).then(() => {
      setIsAssigneeModalOpen(false);
      fetchOrders();
    });
  };
  if (isQuoteReference || assignedToSRT) return null;

  return (
    <>
      <Button onClick={() => setIsAssigneeModalOpen(true)}>{assignTo}</Button>
      {isAssigneeModalOpen && (
        <AddAssigneModal
          setSrtAssignee={handlesetAssignee}
          setAssigneModal={setIsAssigneeModalOpen}
        />
      )}
    </>
  );
};

AssignTo.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default AssignTo;
